import React from "react";
import { Box, Icon, IndexTable, InlineStack, TextField, Tooltip } from "@shopify/polaris";
import { AlertTriangleIcon } from "@shopify/polaris-icons";
import HorseVariant from "../../common/HorseVariant/HorseVariant";
import { assertString, getCurrencySymbol } from "../../../helper_functions/utils";
import { formatMoney } from "../../../helper_functions/utils";
import type { IPurchaseOrder, IPurchaseOrderLineItem } from "../../../api_utils/types";

export default function PurchaseOrderOrderedRow({
  purchaseOrderLineItem,
  index,
  purchaseOrder,
  handleLineItemChange,
  showAvailable = false,
}: {
  readonly purchaseOrderLineItem: IPurchaseOrderLineItem;
  readonly index: number;
  readonly showAvailable?: boolean;
  readonly purchaseOrder: IPurchaseOrder;
  readonly handleLineItemChange: (mLabel: string, id: number) => (newValue?: string) => void;
}): React.ReactElement {
  let errorMessage: string | undefined = undefined;
  console.log(purchaseOrderLineItem.received);
  if (!purchaseOrderLineItem.received || Number(purchaseOrderLineItem.received) === 0) {
    errorMessage = undefined;
  } else if (purchaseOrderLineItem.received > purchaseOrderLineItem.quantity) {
    errorMessage = "Received greater than ordered";
  } else if (purchaseOrderLineItem.received < purchaseOrderLineItem.quantity) {
    errorMessage = "Received less than ordered";
  }

  return (
    <IndexTable.Row id={purchaseOrderLineItem.id.toString()} key={purchaseOrderLineItem.id} position={index + 1}>
      <IndexTable.Cell>
        <div className="medium_hv">
          <HorseVariant key={purchaseOrderLineItem.id} variant={purchaseOrderLineItem} />
        </div>
      </IndexTable.Cell>
      {/* <IndexTable.Cell>
        <div className='w120'>
          <TextField
            onChange={handleLineItemChange('entry_summary_line_number', purchaseOrderLineItem.id)}
            id={purchaseOrderLineItem.id}
            key={purchaseOrderLineItem.id}
            type='integer'
            name='entry_summary_line_number'
            value={assertString(purchaseOrderLineItem?.entry_summary_line_number)}
          />
        </div>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <div className='w120'>
          <TextField
            onChange={handleLineItemChange('description_of_goods', purchaseOrderLineItem.id)}
            id={purchaseOrderLineItem.id}
            key={purchaseOrderLineItem.id}
            name='description_of_goods'
            value={purchaseOrderLineItem?.description_of_goods}
          />
        </div>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <TextField
          onChange={handleLineItemChange('classification_number', purchaseOrderLineItem.id)}
          id={purchaseOrderLineItem.id}
          key={purchaseOrderLineItem.id}
          name='classification_number'
          value={assertString(purchaseOrderLineItem?.classification_number)}
        />
      </IndexTable.Cell>
      <IndexTable.Cell>
        <div className='w120'>
          <TextField
            onChange={handleLineItemChange('duty_rate', purchaseOrderLineItem.id)}
            id={purchaseOrderLineItem.id}
            key={purchaseOrderLineItem.id}
            name='duty_rate'
            suffix='%'
            type='number'
            value={assertString(polis[purchaseOrderLineItem.id]?.duty_rate)} />
        </div>
      </IndexTable.Cell> */}
      <IndexTable.Cell>{purchaseOrderLineItem.warehouse_location}</IndexTable.Cell>
      {showAvailable ? (
        <IndexTable.Cell>{purchaseOrderLineItem.tracked ? purchaseOrderLineItem.currently_available : "∞"}</IndexTable.Cell>
      ) : null}
      <IndexTable.Cell>{purchaseOrderLineItem.quantity}</IndexTable.Cell>
      <IndexTable.Cell>
        <InlineStack align="start" blockAlign="center" gap="100" wrap={false}>
          <Box maxWidth="120px" minWidth="120px" width="120px">
            <TextField
              autoComplete="off"
              id={purchaseOrderLineItem.id.toString()}
              inputMode="numeric"
              key={purchaseOrderLineItem.id}
              label=""
              labelHidden
              name="received"
              onChange={handleLineItemChange("received", purchaseOrderLineItem.id)}
              type="integer"
              value={assertString(purchaseOrderLineItem.received)}
            />
          </Box>
          <Box minWidth="20px" width="20px">
            {errorMessage ? (
              <Tooltip content={errorMessage}>
                <div>
                  <Icon source={AlertTriangleIcon} tone="warning" />
                </div>
              </Tooltip>
            ) : null}
          </Box>
        </InlineStack>
      </IndexTable.Cell>
      <IndexTable.Cell>
        <div className="w120">
          <TextField
            align="right"
            autoComplete="off"
            id={purchaseOrderLineItem.id.toString()}
            key={purchaseOrderLineItem.id}
            label="Cost"
            labelHidden
            name="cost"
            onChange={handleLineItemChange("cost", purchaseOrderLineItem.id)}
            placeholder="0.00"
            prefix={getCurrencySymbol(purchaseOrder.currency)}
            type="currency"
            value={assertString(purchaseOrderLineItem.cost)}
          />
        </div>
      </IndexTable.Cell>
      {/* <IndexTable.Cell>
        {formatMoney(getDuties(purchaseOrderLineItem), purchaseOrder.currency)}
      </IndexTable.Cell> */}
      <IndexTable.Cell>
        {formatMoney(
          Number(purchaseOrderLineItem.quantity || 0) * Number(purchaseOrderLineItem.cost || 0),
          purchaseOrder.currency,
        )}
      </IndexTable.Cell>
    </IndexTable.Row>
  );
}
